module.exports = __webpack_public_path__ + "static/media/0018t.c24b4bec.jpg";